<template>
	<v-btn-toggle v-model="toggle" style="width: 100%" class="elevation-2">
		<v-btn
			large
			v-for="item in items"
			:key="item.status"
			@click="setSelectStatusBet(item.status)"
			style="flex: 1"
		>
			<v-icon left :color="handleColorStatus(item.status)" size="12"
				>mdi-circle</v-icon
			>
			{{ item.text }}
		</v-btn>
	</v-btn-toggle>
</template>
<script>
	export default {
		name: "components-common-filters-select-status-bet",
		data: () => ({
			toggle: null,
		}),
		computed: {
			items() {
				return [
					{ text: this.$t("doActives"), status: 1 },
					{ text: this.$t("cancelleds"), status: 0 },
				];
			},
			statusBet() {
				return this.$store.state.filters.selectStatusBet.status;
			},
		},
		mounted() {
			this.toggle = this.statusBet == 1 ? 0 : 1;
		},
		methods: {
			setSelectStatusBet(status) {
				this.$store.commit("setSelectStatusBet", status);
			},
			handleColorStatus(status) {
				if (status == 0) return "purple";
				if (status == 1) return "green";
			},
		},
	};
</script>
